import { useEffect, useRef } from 'react';
import { Button, Row, Spin } from 'antd';
import clsx from 'clsx';

import { useCategory } from '../../../../../store/category';
import { Left } from '../../../../Common/Icon';
import CategoryButton from '../CategoryButton';
import { useCategoryContext } from '../CategoryProvider';

import styles from './index.module.scss';

interface CategoryCarouselProps {
  className?: string;
}

function CategoryCarousel({ className }: CategoryCarouselProps) {
  const { setCategoryId, categoryId } = useCategoryContext();

  const { listAll } = useCategory();
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleScroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const scrollAmount = container.offsetWidth / 2;

    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (!categoryId || listAll.loading) return;

    const el = document.getElementById(categoryId);
    const parent = el?.parentElement;

    if (parent) {
      parent.scrollTo({
        left: el.offsetLeft - parent.clientWidth / 2 + el.clientWidth / 2,
        behavior: 'smooth',
      });
    }
  }, [categoryId, listAll.loading]);

  return (
    <div className={clsx(styles.wrapper, className)}>
      <Button
        icon={<Left />}
        className={clsx(styles.btnControll, styles.btnLeft)}
        onClick={() => handleScroll('left')}
      />
      <div className={styles.scrollContainer} ref={scrollRef}>
        {listAll.loading ? (
          <Row justify="center" style={{ width: '100%' }}>
            <Spin />
          </Row>
        ) : (
          listAll.response?.data.map((item) => (
            <CategoryButton
              key={item.id}
              category={item}
              isActive={item.id === categoryId}
              onClick={() => setCategoryId(item.id)}
            />
          ))
        )}
      </div>
      <Button
        icon={<Left />}
        className={clsx(styles.btnControll, styles.btnRight)}
        onClick={() => handleScroll('right')}
      />
    </div>
  );
}

export default CategoryCarousel;
